module.exports = __webpack_public_path__ + "resources/img/img_intro_certi7.6b6b0e07771bc4d9e5013f66a39b9694.png";